import {fetch} from "utils/dataAccess";

export function returningRetailerItem(item) {
    return new Promise((resolve, reject) => {
        fetch(`line_items/${item.id}/returning-retailer`, {
            method: 'PUT',
            headers: new Headers({'Content-Type': 'application/ld+json'}),
            body: JSON.stringify({})
        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}